var n=function(n){return{name:n,transitions:function(t){return{name:n,transitions:t}}}};export{n as defineTransitionalState};
//# sourceMappingURL=defineTransitionalState.js.map